import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReciboService {

  private urlApi = environment.rootUrlApi + 'recibo';

  constructor(private http: HttpClient) { }

  public recibo(id_pedido: number): Observable<any> {
    return this.http.get<any>(this.urlApi + '/getRecibo/' + id_pedido);
  }
}
